import { Component, OnInit, inject } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { FavouritesService } from '../../services/favourites.service';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { ThumbnailComponent } from '../thumbnail/thumbnail.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-favourites',
    templateUrl: './favourites.component.html',
    styleUrls: ['./favourites.component.scss'],
    imports: [BreadCrumbComponent, ThumbnailComponent, AsyncPipe]
})
export class FavouritesComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);
  favouritesService = inject(FavouritesService);
  private headService = inject(HeadService);
  private titleService = inject(TitleService);


  ngOnInit(): void {
    this.render();
  }

  render(): void {
    const title = 'My Favourites';
    this.titleService.set(title);
    this.breadcrumbService.set(title);
    this.headService.setMetaDescription(title);
    this.favouritesService.fetch();
  }
}
